import { useState } from 'react'

import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { DialogPelaksanaanAppealApproval } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealApproval'
import { DialogPelaksanaanAppealRejection } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRejection'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { KinerjaTipe } from 'types/kinerja'
import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import type {
  TPelaksanaanAppealState,
  TPelaksanaanAppealableStep,
} from 'types/kinerja-pelaksanaan'

type CardNotificationPelaksanaanAppealKSProps = CardNotificationBaseProps & {
  appealState?: TPelaksanaanAppealState
  guruName: string
  notificationId?: string
  step: TPelaksanaanAppealableStep
  tipe?: KinerjaTipe
}

export function CardNotificationPelaksanaanAppealKS({
  appealState,
  guruName,
  notificationId,
  step,
  tipe = 'SPF',
  ...cardProps
}: CardNotificationPelaksanaanAppealKSProps) {
  const [activeDialog, setActiveDialog] = useState<
    'NONE' | 'APPEAL_APPROVAL' | 'APPEAL_REJECTION'
  >('NONE')

  const SCREEN_NAME = 'ks_penilaian_home'

  const { trackEvent } = useSKPPelaksanaanTrackEvent()

  const handleCloseDialog = () => setActiveDialog('NONE')

  const handleApproveCTA = () => {
    setActiveDialog('APPEAL_APPROVAL')
    trackEvent({
      activity_type: 'penilaian_ks_home_click_accept_and_reassess',
      event_trigger: SCREEN_NAME,
      screen_name: SCREEN_NAME,
    })
  }

  const handleRejectCTA = () => {
    setActiveDialog('APPEAL_REJECTION')
    trackEvent({
      activity_type: 'penilaian_ks_home_click_reject_application',
      event_trigger: SCREEN_NAME,
      screen_name: SCREEN_NAME,
    })
  }

  const renderAppealResult = (
    state: CardNotificationPelaksanaanAppealKSProps['appealState']
  ) => {
    switch (state) {
      case 'APPROVED':
        return <Badge variant="success">Pengajuan sudah diterima</Badge>
      case 'REJECTED':
        return <Badge>Pengajuan sudah ditolak</Badge>
      default:
        return (
          <div className="flex space-x-6 mt-6">
            <Button size="sm" color="blue" onClick={handleApproveCTA}>
              Terima dan nilai ulang dokumen
            </Button>
            <Button
              size="sm"
              color="blue"
              variant="ghost"
              onClick={handleRejectCTA}
            >
              Tolak pengajuan
            </Button>
          </div>
        )
    }
  }

  return (
    <KinerjaTipeProvider tipe={tipe}>
      <CardNotificationBase {...cardProps}>
        {renderAppealResult(appealState)}

        <DialogPelaksanaanAppealApproval
          isOpen={activeDialog === 'APPEAL_APPROVAL'}
          guruName={guruName}
          requestId={notificationId}
          step={step}
          onClose={handleCloseDialog}
        />

        <DialogPelaksanaanAppealRejection
          isOpen={activeDialog === 'APPEAL_REJECTION'}
          guruName={guruName}
          requestId={notificationId}
          step={step}
          onClose={handleCloseDialog}
        />
      </CardNotificationBase>
    </KinerjaTipeProvider>
  )
}
